/* eslint-disable import/prefer-default-export */
import { ParamTypes } from './OhsRegisterModels';

export const globalFilterDefaults = {
  [ParamTypes.Archived]: false,
  [ParamTypes.Confidential]: false,

  [ParamTypes.ShowSignedOff]: false,
  [ParamTypes.Sort]: '',
  [ParamTypes.Tab]: '',
  [ParamTypes.FolderView]: false,
  [ParamTypes.Severities]: undefined,
  [ParamTypes.Categories]: undefined,
  [ParamTypes.SubCategories]: undefined,
  [ParamTypes.Workplaces]: undefined,
  [ParamTypes.Modules]: undefined,
  [ParamTypes.DateDue]: '',
  [ParamTypes.DateDueType]: '',
  [ParamTypes.DateOccurred]: '',
  [ParamTypes.DateCompleted]: { start: '', end: '' },
  [ParamTypes.DateSignedoff]: { start: '', end: '' },
  [ParamTypes.DateCreated]: { start: '', end: '' },
  [ParamTypes.DateIdentified]: { start: '', end: '' },
  [ParamTypes.DateIssued]: { start: '', end: '' },
  [ParamTypes.ReviewScheduled]: false,
  [ParamTypes.Copied]: false,
  [ParamTypes.CopiedVersionUpdated]: false,
  [ParamTypes.NotCopied]: false,
  [ParamTypes.Category]: '',
  [ParamTypes.Subcategory]: '',

  [ParamTypes.SearchKey]: '',
  [ParamTypes.SubstringSearch]: true,
  [ParamTypes.SkipOrgRecords]: false,
  [ParamTypes.SkipAllocatedRecords]: false,
  [ParamTypes.Leave]: undefined,
  [ParamTypes.IncludeTierNull]: true,
  [ParamTypes.Status]: undefined,

  [ParamTypes.Page]: 1,
  [ParamTypes.Next]: '',
};
